import * as React from 'react'
import Box from '@eversports/klimt-primitives/Box'
import NoSsr from '@eversports/klimt-design-components/NoSsr'
import Stack from '@eversports/klimt-primitives/Stack'
import Heading from '@eversports/klimt-primitives/Heading'
import { useSettingsContext } from '@eversports/react-app-base/SettingsContext'
import FacebookIcon from '@eversports/design-tokens/assets/icons/facebook.svg'
import YoutubeIcon from '@eversports/design-tokens/assets/icons/youtube.svg'
import InstagramIcon from '@eversports/design-tokens/assets/icons/instagram.svg'
import Icon from '@eversports/klimt-primitives/Icon'

import StoreBadge from '../StoreBadge'
import { Localized } from '../../localization/react'

import { BLOG_LINK, FooterLinksMapping } from './footer-links-mapping'
import CookieBanner from './CookieBanner/CookieBanner'
import { FooterLink } from './FooterLink'

const StaticFooterComponent = () => {
  const { tld } = useSettingsContext()
  const footerLinks = FooterLinksMapping[tld]

  return (
    <Stack direction="row" justifyContent="space-between" flexWrap="wrap" color="lightgray">
      <Stack direction="row" flex="1">
        <Stack gap={2} flex="1" sx={{ margin: '24px 16px' }}>
          <Heading is="h2" variant="large" sx={{ color: 'white' }}>
            <Localized id="footer-header-more-of-eversports" />
          </Heading>
          <FooterLink to={footerLinks.about}>
            <Localized id="footer-about-us" />
          </FooterLink>
          <FooterLink to={BLOG_LINK}>
            <Localized id="footer-blog" />
          </FooterLink>
          <FooterLink to={footerLinks.career}>
            <Localized id="footer-career" />
          </FooterLink>
          <FooterLink to="/h/security">
            <Localized id="footer-security" />
          </FooterLink>
          <FooterLink to={footerLinks.corporate}>
            <Localized id="footer-for-corporates" />
          </FooterLink>
        </Stack>
        <Stack gap={2} flex="1" sx={{ margin: '24px 16px' }}>
          <Heading is="h2" variant="large" sx={{ color: 'white' }}>
            <Localized id="footer-header-eversports-manager" />
          </Heading>
          <FooterLink to={footerLinks.website}>
            <Localized id="footer-visit-the-website" />
          </FooterLink>
          <FooterLink to={footerLinks.pricing}>
            <Localized id="footer-pricing" />
          </FooterLink>
          <FooterLink to={footerLinks.demo}>
            <Localized id="footer-demo" />
          </FooterLink>
        </Stack>
      </Stack>
      <Stack direction="row" flex="1">
        <Stack gap={2} flex="1" sx={{ margin: '24px 16px' }}>
          <Heading is="h2" variant="large" sx={{ color: 'white' }}>
            <Localized id="footer-header-contact" />
          </Heading>
          <FooterLink to="/h/contact">
            <Localized id="footer-contact-us" />
          </FooterLink>
          <FooterLink to="/h/about">
            <Localized id="footer-impressum" />
          </FooterLink>
          <FooterLink to="/h/privacy">
            <Localized id="footer-data-protection" />
          </FooterLink>
          <FooterLink to="/h/terms">
            <Localized id="footer-terms-and-conditions" />
          </FooterLink>
          <NoSsr defer>
            <CookieBanner />
          </NoSsr>
          <FooterLink to="/h/cancel-membership">
            <Localized id="footer-cancel-membership" />
          </FooterLink>
        </Stack>
        <Stack gap={4} flex="1" sx={{ margin: '24px 16px' }}>
          <Stack gap={2}>
            <Heading is="h2" variant="large" sx={{ color: 'white' }}>
              <Localized id="footer-header-social-media" />
            </Heading>
            <Stack direction="row" gap={4}>
              <FooterLink to={footerLinks.facebook} ariaLabel="Eversports Facebook">
                <Box sx={{ padding: '10px', borderRadius: '8px', backgroundColor: '#333333' }}>
                  <Icon src={FacebookIcon} color="mediumgray" size="default" />
                </Box>
              </FooterLink>
              <FooterLink to={footerLinks.youtube} ariaLabel="Eversports Manager Youtube">
                <Box sx={{ padding: '10px', borderRadius: '8px', backgroundColor: '#333333' }}>
                  <Icon src={YoutubeIcon} color="mediumgray" size="default" />
                </Box>
              </FooterLink>
              <FooterLink to={footerLinks.instagram} ariaLabel="Eversports Instagram">
                <Box sx={{ padding: '10px', borderRadius: '8px', backgroundColor: '#333333' }}>
                  <Icon src={InstagramIcon} color="mediumgray" size="default" />
                </Box>
              </FooterLink>
            </Stack>
          </Stack>
          <Stack gap={2} marginTop={2} width="fit-content">
            <StoreBadge type="app-store" height="44px" width="164px" />
            <StoreBadge type="play-store" height="44px" width="164px" />
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  )
}

export default StaticFooterComponent
